import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React from 'react';
import { TUXRadio } from '../TUXRadio/TUXRadio.js';
import { TUXTableCell } from './TUXTableCell.js';

var _excluded = ["title", "subTitle", "icon", "disabled"];
var TUXTableRadioCell = function TUXTableRadioCell(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      disabled = _ref.disabled,
      radioProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TUXTableCell, {
    title: title,
    subTitle: subTitle,
    icon: icon,
    disabled: disabled,
    accessoryType: "radio",
    accessory: /*#__PURE__*/React.createElement(TUXRadio, _extends({
      size: "medium"
    }, radioProps, {
      disabled: disabled
    })),
    hostCanBeClick: true,
    accessoryHasTextProps: false,
    shouldWrapWithLabel: true
  });
};

export { TUXTableRadioCell };
//# sourceMappingURL=TUXTableRadioCell.js.map
